import { c as _c } from "react/compiler-runtime";
import Image, { type StaticImageData } from 'next/image';
import { Text } from '@/components/text';
interface CastCardProps {
  id: string;
  name: string;
  role: string;
  image: StaticImageData;
}
export function CastCard(t0) {
  const $ = _c(18);
  const {
    id,
    name,
    role,
    image
  } = t0;
  let t1;
  if ($[0] !== id) {
    const getObjectPosition = () => {
      const positions = {
        "andrew-linzey": {
          default: "left",
          tablet: "10%",
          mobile: "25%"
        },
        "michael-beckwith": {
          default: "center",
          tablet: "25%",
          mobile: "35%"
        },
        "louis-caruna": {
          default: "43%",
          tablet: "43%",
          mobile: "38%"
        },
        "deborah-rooke": {
          default: "60%",
          tablet: "50%",
          mobile: "40%"
        },
        "robert-eisenman": {
          default: "center",
          tablet: "35%",
          mobile: "25%"
        },
        "james-tabor": {
          default: "35%",
          tablet: "60%",
          mobile: "25%"
        }
      };
      return positions[id] || {
        default: "center"
      };
    };
    t1 = getObjectPosition();
    $[0] = id;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const position = t1;
  const t2 = `${name} - ${role}`;
  let t3;
  if ($[2] !== position.default) {
    t3 = {
      objectPosition: position.default
    };
    $[2] = position.default;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== image || $[5] !== t2 || $[6] !== t3) {
    t4 = <Image src={image} alt={t2} fill={true} sizes="(max-width: 768px) 100vw, (max-width: 1024px) 50vw, 33vw" quality={65} className="object-cover" style={t3} />;
    $[4] = image;
    $[5] = t2;
    $[6] = t3;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== name) {
    t5 = <Text as="p" className="font-eiko font-semibold text-[2rem] leading-none sm:text-[3.5rem]">{name}</Text>;
    $[8] = name;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== role) {
    t6 = <Text as="p" className="mt-3 font-formula-condensed font-normal text-[1.4rem] uppercase tracking-[0.04em] sm:mt-5 sm:text-[1.6rem]">{role}</Text>;
    $[10] = role;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== t5 || $[13] !== t6) {
    t7 = <div className="absolute right-0 bottom-0 left-0 z-10 flex w-full items-end justify-start bg-linear-to-t from-black/30 via-black/20 to-transparent p-4 sm:justify-end sm:p-8 lg:p-12"><div className="text-white">{t5}{t6}</div></div>;
    $[12] = t5;
    $[13] = t6;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  let t8;
  if ($[15] !== t4 || $[16] !== t7) {
    t8 = <div className="relative h-[70svh] w-full md:h-[80svh] md:max-h-[600px]">{t4}{t7}</div>;
    $[15] = t4;
    $[16] = t7;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  return t8;
}